import React, { useState } from "react";

import ArrowTrgDownIcon from "../../icons/arrow-trg-down";

interface CollapsibleCardProps {
  title: string;
  children: React.ReactNode;
}

function CollapsibleCard({ title, children }: CollapsibleCardProps) {
  const [isOpen, setIsOpen] = useState(false);

  const toggleCard = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="rounded-xl bg-white py-6 px-5">
      <div className="flex justify-between items-center cursor-pointer" onClick={toggleCard}>
        <h2 className="text-lg font-bold text-[#171A20]" dangerouslySetInnerHTML={{ __html: title }} />
        <button className="focus:outline-none">
          <div className={`transform transition-transform duration-300 ${isOpen ? "rotate-180" : ""}`}>
            <ArrowTrgDownIcon />
          </div>
        </button>
      </div>
      <div
        className={`overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? "max-h-screen mt-4" : "max-h-0"}`}>
        {children}
      </div>
    </div>
  );
}

export default CollapsibleCard;
